module.exports = __webpack_public_path__ + "static/media/graduate-2.e14a639e.png";